import { styled } from "@mui/material";

import { Select as UnstyledSelect } from "@citrine/atoms/select";

export const Select = styled(UnstyledSelect)(({ theme, value }) => {
  const backgroundColor =
    value === "model-expert"
      ? theme.palette.predictor.light
      : theme.palette.info.light;

  return {
    "& .MuiInputBase-root": {
      backgroundColor,
      borderRadius: theme.spacing(1.5),
      height: theme.spacing(3),
      ":hover": {
        backgroundColor,
      },

      "&.MuiSelect-filled": {
        paddingRight: theme.spacing(3),
      },
      "&.Mui-focused": {
        backgroundColor,
      },
    },

    "& .MuiInputBase-formControl": {
      fontSize: theme.spacing(1.5),
      letterSpacing: "0.5px",
    },

    "& .MuiSelect-select": {
      gap: theme.spacing(0.5),
      "&&&": {
        padding: theme.spacing(0, 3, 0, 0.75),
      },
      ":focus": {
        backgroundColor: "initial",
      },
    },

    "& .MuiSelect-filled ~ .MuiSelect-icon": {
      right: 0,
    },
  };
}) as typeof UnstyledSelect;
